import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes: 5 * 60 seconds * 1000 milliseconds
            cacheTime: 10 * 60 * 1000, // 10 minutes: 10 * 60 seconds * 1000 milliseconds
            refetchOnWindowFocus: true,
            retry: 2,
        },
    },
});
